import React from "react";
import ReactDOM from "react-dom/client";
import AppWrapper from "./AppWrapper";
import AppAccessLoginPage from "./AppAccessLoginPage";
import LandingPage from "./LandingPage";
import WaitlistPage from "./WaitlistPage";
import { settlementNetworkForPath } from "./networks/registry";
import "./index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
const pathname =
  typeof window !== "undefined"
    ? window.location.pathname.replace(/\/+$/, "") || "/"
    : "/";
const isWalletRoute = pathname === "/app";
const isAppAccessLoginRoute = pathname === "/app-login";
const isWaitlistRoute = pathname === "/waitlist";

// Each registered settlement network answers its mount path and its
// `/send` payment-link path; all render the shared wallet with that network.
const routeNetwork = settlementNetworkForPath(pathname);

root.render(
  <React.StrictMode>
    {isAppAccessLoginRoute ? (
      <AppAccessLoginPage />
    ) : isWaitlistRoute ? (
      <WaitlistPage />
    ) : isWalletRoute || routeNetwork ? (
      <AppWrapper />
    ) : (
      <LandingPage />
    )}
  </React.StrictMode>,
);
